import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar'; 
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'; 
import { withStyles } from '@material-ui/core/styles';

import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { HORIZONTAL_LOGO as theLogo } from '../../constants';

import AcceptableUse from '../../assets/legaldocs/acceptable-use';
import TermsOfUse from '../../assets/legaldocs/terms';
import PrivacyPolicy from '../../assets/legaldocs/privacy';

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: '8px',
    textAlign: 'left'
  },
}))(MuiExpansionPanelDetails);
  
const useStyles = makeStyles(theme => ({
  root: {
    // background: '#fff',
    // maxWidth: '80%',
    margin: 'auto',
    borderRadius: '8px',
    marginTop: 64,
    padding: '30px'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {

  },
  quote: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: 'white',
    fontWeight: 300
  },
  name: {
    marginTop: '8px',
    color: 'white'
  },
  bio: {
    color: 'white'
  },
  contentContainer: {},
  content: {
    height: '90%',
    margin: 'auto',
    textAlign: 'center',
    maxWidth: '100%'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingBototm: '8px',
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  logoImage: {
    marginLeft: '16px'
  },
  panelSpacer: {
    width: 1,
    height: '10vh',
    minHeight: 48,
},
  contentBody: {
    flexGrow: 1,
    display: 'flex', 
  },
  form: {
    borderRadius: '8px',
    textAlign: 'center',
    alignItems: 'center',
    position: 'relative',
    paddingTop: 15,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom:50,

    background: '#fff'
  },
  title: {
    marginTop: '8px'
  },
  textField: {
    marginTop: '8px'
  },
  policy: {
    marginTop: '4px',
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  signUpButton: {
  
    width: "60%",
    color:'white',
  }, 
  buttonProgress: { 
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  panelSpacer: {
    // height: '15vh',
    // minHeight: 208,
  }
}));
 

export default function TermsAndConditions(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState('');

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

 

  return (
    <div className={classes.root}>
         <style>{ `.pageBody { background: #000055; }` }</style>
    <Grid
       className={classes.content}
       item
       lg={12}
       xs={12}
       alignItems="left" 
     >
       <div className={classes.content}>
         <div className={classes.contentBody}>
  
    <React.Fragment>
       
      <Container maxWidth="md" component="main" className={'panelSpacer'}>
         {/* <div>

           <img src={theLogo} 
            alt="SoilHealthAcademy.org" 
            width="200px" 
            align='middle' 
            className='course-logo'
            />
        </div> */}
        <Typography component="h1" variant="h5" align="left" color="textPrimary" gutterBottom style={{margin: 24}}>
          Terms, Conditions, and Policies
  
        </Typography>
        <ExpansionPanel square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <ExpansionPanelSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>Acceptable Use Policy</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
              <AcceptableUse />
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <ExpansionPanelSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>Terms of Use</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
              <TermsOfUse />
                 </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <ExpansionPanelSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>Privacy Policy</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
              <PrivacyPolicy />
        </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
       </Container>
       
    </React.Fragment>
    </div>
    </div>
    </Grid>
 
    </div>
  );
}